export const dateSelectorEnabledDeliveryMethods = {
    JP: ["JP01"],
};

export const isDateAndTimeEnabledForDeliveryMethod = (deliveryMethod: string, locale: string) => {
    const countryCode = locale.split("-")[1];
    return dateSelectorEnabledDeliveryMethods[countryCode]?.includes(deliveryMethod);
};
